module.exports = __webpack_public_path__ + "static/media/download.698a1c2d.svg";